/* eslint-disable no-undef */
/* eslint-disable import/extensions */
import { call, put, takeEvery } from "redux-saga/effects";
import { objectToQueryString } from "helpers/queryString";

import {
	ActionsSearchUsers,
	failureSearchUsers,
	loadGetSearchUsers,
	loadSearchUsersSuccess,
} from "./actions";

function* loadDataSearchUsers(params = {}) {

	try {

		yield put(loadGetSearchUsers());
		const queryParams = objectToQueryString({
			next_id: params.payload.next_id,
			page: !params.payload.next_id ? params.payload.page : 1,
			limit: params.payload.limit,
			type: params.payload.type,
			sort: params.payload.sort,
			keyword: params.payload.keyword,
		});
		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/searchUsers?${queryParams}`;
		const headers = params.payload.is_server
			? { ...params.payload.headers }
			: {
				...params.payload.headers,
				// endpoint: api_endpoint,
			};
		const method = "GET";
		const options = { headers, method };

		const response = yield call(fetch, endpoint, options);
		if (response.status >= 200 && response.status < 300) {

			const data = yield response.json();

			yield put(loadSearchUsersSuccess(data));

		}

	} catch (err) {

		yield put(failureSearchUsers(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsSearchUsers.GET_SEARCH_USERS, loadDataSearchUsers);

}
